module.exports = __webpack_public_path__ + "static/featuredBlockLayout1Back-48fd395412b198ce463433a5262a1f6e.png";